import { render, staticRenderFns } from "./CampaignConversationFlow.vue?vue&type=template&id=4a280e9c&scoped=true&"
import script from "./CampaignConversationFlow.vue?vue&type=script&lang=js&"
export * from "./CampaignConversationFlow.vue?vue&type=script&lang=js&"
import style0 from "./CampaignConversationFlow.vue?vue&type=style&index=0&id=4a280e9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a280e9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VIcon,
})
